import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import Skeleton from '@mui/material/Skeleton';
import { stakingCardSkeletonStyles } from './stakingCardSkeletonStyles';
import { useTranslation } from 'react-i18next';
import { ConnectWalletCard } from '../ConnectWalletCard/ConnectWalletCard';
import { Paper } from '@mui/material';
import { useWallet } from '../../hooks/useWallet';

export const StakingCardSkeleton = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isDark = theme.palette.mode === 'dark';
  const classes = stakingCardSkeletonStyles(isDark);
  const { isWalletConnected } = useWallet();
  return (
    <Paper sx={classes.paperSkeleton}>
      <Grid container direction='column' rowSpacing={2}>
        <Grid
          item
          container
          columnSpacing={1}
          direction={{ xs: 'row', md: 'row' }}
          justifyContent='space-between'
          sx={classes.rowContainerWallet}
          wrap='nowrap'
        >
          <Grid item xs={12}>
            <Skeleton variant='rectangular' height={60} />
          </Grid>
        </Grid>
        {!isWalletConnected && (
          <Grid item>
            <ConnectWalletCard text={t('vesting.connect_wallet.data_text')} />
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};
